<template>
  <div class="py-12 px-4">
    <div class="flex flex-col items-center mb-10">
      <h2 class="text-2xl font-bold mb-2">実績</h2>
      <p class="text-gray-500 text-sm">主な開発・参画実績</p>
      <div class="w-12 h-1 bg-blue-500 mt-3 rounded"></div>
    </div>

    <div class="flex flex-wrap gap-2 justify-center mb-8">
      <button
        v-for="tag in filterTags"
        :key="tag"
        @click="activeTag = tag"
        :class="[
          'px-4 py-1.5 rounded-full text-sm font-medium transition-colors',
          activeTag === tag
            ? 'bg-blue-500 text-white'
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        ]"
      >
        {{ tag }}
      </button>
    </div>

    <div class="grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-6 max-w-5xl mx-auto">
      <div
        v-for="item in filteredItems"
        :key="item.title"
        class="bg-white border border-gray-100 rounded-xl shadow-sm hover:shadow-md transition-shadow p-5"
      >
        <div class="flex items-center justify-between mb-3">
          <span class="text-xs font-semibold px-2.5 py-1 rounded-full" :class="item.categoryColor">
            {{ item.category }}
          </span>
        </div>
        <h3 class="font-semibold text-gray-800 mb-2 text-sm leading-snug">{{ item.title }}</h3>
        <p class="text-xs text-gray-500 mb-4 leading-relaxed">{{ item.description }}</p>
        <div class="flex flex-wrap gap-1.5">
          <span
            v-for="tech in item.techs"
            :key="tech"
            class="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded"
          >
            {{ tech }}
          </span>
        </div>
      </div>
    </div>

    <div class="text-center mt-12">
      <p class="text-gray-500 text-sm mb-4">このような開発のご依頼、お気軽にご相談ください</p>
      <a
        href="#inquiry"
        class="inline-block bg-blue-500 hover:bg-blue-600 transition-colors text-white font-semibold px-8 py-3 rounded-full shadow"
      >
        無料で相談する →
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PortfolioSection',
  data() {
    return {
      activeTag: 'すべて',
      items: [
        {
          category: 'AI / ML',
          categoryColor: 'bg-red-100 text-red-700',
          title: '企業向けAIチャットボット（RAG）',
          description: '社内文書を参照する企業向けAIチャットボットを開発。設定画面、回答生成、検索連携、開発基盤や運用環境の整備まで担当しました。',
          techs: ['SvelteKit', 'FastAPI', 'Azure OpenAI', 'Azure AI Search'],
          tag: 'AI / ML'
        },
        {
          category: 'EdTech',
          categoryColor: 'bg-teal-100 text-teal-700',
          title: 'デジタルノートアプリ PoC（フロントエンド）',
          description: 'デジタルノートアプリのPoC開発に参画。手書き機能の実装、ノート管理画面の構築、共通UIの部品化を担当しました。',
          techs: ['Next.js', 'React', 'Fabric.js', 'Storybook'],
          tag: 'Webアプリ'
        },
        {
          category: 'HR Tech',
          categoryColor: 'bg-indigo-100 text-indigo-700',
          title: 'スキマバイトアプリ バックエンド開発リーダー',
          description: 'スキマバイトアプリのバックエンド開発をリード。請求や承認、支払い、検索、チャットなどの機能開発に加え、仕様調整や性能改善も担当しました。',
          techs: ['Go', 'GraphQL', 'GCP', 'Cloud SQL'],
          tag: 'Webアプリ'
        },
        {
          category: 'SaaS',
          categoryColor: 'bg-purple-100 text-purple-700',
          title: 'お悩み相談サイト 新規開発（フルスタック）',
          description: '新規相談サービスの立ち上げを、要件定義から開発基盤整備まで一貫して担当。リアルタイム機能、認証、API、画面実装、インフラ整備まで対応しました。',
          techs: ['Go', 'Next.js', 'Terraform', 'AWS'],
          tag: 'Webアプリ'
        },
        {
          category: 'SaaS',
          categoryColor: 'bg-purple-100 text-purple-700',
          title: 'フィットネスジムアプリ向け管理サイト開発',
          description: 'フィットネスアプリ運営向けの管理サイト開発に参画。管理画面の機能実装に加え、複数の社内外サービスをつなぐAPI連携や認証まわりを担当しました。',
          techs: ['Ruby on Rails', 'Nuxt.js', 'TypeScript', 'AWS'],
          tag: 'Webアプリ'
        },
        {
          category: 'SaaS',
          categoryColor: 'bg-purple-100 text-purple-700',
          title: 'eKYC（電子本人確認）SaaSプロダクト',
          description: '電子本人確認サービスのコア機能開発に参画。本人確認フローの整理と、関連APIの実装を担当しました。',
          techs: ['Ruby on Rails', 'AWS', 'Redis'],
          tag: 'Webアプリ'
        },
        {
          category: 'FinTech',
          categoryColor: 'bg-green-100 text-green-700',
          title: '法人カード決済プロセッサー開発',
          description: '法人カード決済の承認処理まわりの開発に参画。決済制御機能の追加、周辺APIの実装、テストや開発フローの整備を担当しました。',
          techs: ['Go', 'gRPC', 'GCP', 'Cloud Spanner'],
          tag: 'Webアプリ'
        },
        {
          category: 'Web3',
          categoryColor: 'bg-yellow-100 text-yellow-700',
          title: 'リツイート報酬配布サービス（DApp）',
          description: 'SNSキャンペーン向けの報酬配布サービスを開発。スマートコントラクト実装、外部API連携、報酬配布フローや運用向け機能の実装を担当しました。',
          techs: ['Solidity', 'Vue.js', 'Firebase', 'Firestore'],
          tag: 'Web3'
        },
        {
          category: 'AI / ML',
          categoryColor: 'bg-red-100 text-red-700',
          title: '自動音声認識（ASR）サービス開発',
          description: '音声認識サービスの開発に参画。文字起こしAPIや非同期処理基盤の実装、精度比較用アプリの開発、運用改善に向けた基盤整備を担当しました。',
          techs: ['Python', 'Flask', 'Nuxt.js', 'AWS'],
          tag: 'AI / ML'
        },
        {
          category: 'マッチング',
          categoryColor: 'bg-pink-100 text-pink-700',
          title: 'オーディション・タレントマッチングサイト',
          description: 'オーディション情報を扱うマッチングサイト開発に参画。機能追加に加え、インフラ整備、ログイン連携、表示速度改善など幅広く対応しました。',
          techs: ['PHP', 'FuelPHP', 'AWS', 'MySQL'],
          tag: 'Webアプリ'
        },
        {
          category: 'SaaS',
          categoryColor: 'bg-purple-100 text-purple-700',
          title: 'レベニューシェア型生産システム',
          description: '収益管理を支える業務システム開発に参画。ログイン機能、集計画面、外部連携用APIの実装に加え、仕様確認やデータ設計にも関わりました。',
          techs: ['Ruby on Rails', 'Oracle', 'MySQL', 'Redis'],
          tag: 'Webアプリ'
        },
        {
          category: 'メディア',
          categoryColor: 'bg-orange-100 text-orange-700',
          title: '旅行ポータルサイト 機能追加・改修',
          description: '旅行ポータルサイトの改善開発に参画。投稿機能や管理機能の追加、集計処理の実装、性能改善やSEOまわりの改修を担当しました。',
          techs: ['Ruby on Rails', 'PHP', 'MySQL', 'Memcache'],
          tag: 'Webアプリ'
        },
        {
          category: 'HR Tech',
          categoryColor: 'bg-indigo-100 text-indigo-700',
          title: '人事向け採用管理システム',
          description: '採用管理システムの機能開発に参画。レポート機能、日程調整、外部サービス連携、調査やテスト実装まで継続的に対応しました。',
          techs: ['Ruby on Rails', 'React', 'GCP', 'BigQuery'],
          tag: 'Webアプリ'
        },
        {
          category: 'SFA / CRM',
          categoryColor: 'bg-blue-100 text-blue-700',
          title: '不動産売買事業者向け営業支援システム（SFA）',
          description: '不動産事業者向け営業支援システムを、要件整理からリリースまで一貫して担当。顧客管理、物件提案、外部連携、集計機能などを実装しました。',
          techs: ['Ruby on Rails', 'Vue.js', 'AWS', 'Aurora'],
          tag: 'Webアプリ'
        },
        {
          category: 'メディア',
          categoryColor: 'bg-orange-100 text-orange-700',
          title: '業務システムSaaS比較サイト',
          description: '業務システム比較サイトの立ち上げ開発を担当。認証機能、製品管理、比較ロジック、管理機能などをフルスタックで実装しました。',
          techs: ['Ruby on Rails', 'Vue.js', 'Nuxt.js', 'AWS'],
          tag: 'Webアプリ'
        },
      ]
    }
  },
  computed: {
    filterTags() {
      const tags = ['すべて', ...new Set(this.items.map(i => i.tag))]
      return tags
    },
    filteredItems() {
      if (this.activeTag === 'すべて') return this.items
      return this.items.filter(i => i.tag === this.activeTag)
    }
  }
}
</script>
